// Generated from the picker <select> options in App.js. Keep in sync.
export const ASSET_LABELS = {
  "outfit": {
    "apefest_merch_2025": "Apefest Merch 2025",
    "vegas": "Vegas BAYC",
    "german_ape_club_clothes": "German Ape Club",
    "mindfully_bored_hoodie": "Mindfully Bored Hoodie",
    "ape_solar_hoodie_black": "Ape Solar Hoodie Black",
    "ape_solar_hoodie_blue": "Ape Solar Hoodie Blue",
    "apefest_merch": "Apefest Merch",
    "tt_hoodie": "Top Trader Hoodie",
    "bimmer_jacket": "Bimmer Jacket",
    "apechain_hoodie_black": "Apechain Hoodie Black",
    "apechain_hoodie_orange": "Apechain Hoodie Orange",
    "apechain_hoodie_blue": "Apechain Hoodie Blue",
    "apefest_jacket": "Apefest Jacket",
    "cheetah_hoodie": "Cheetah Hoodie",
    "naked": "No Clothes",
    "french_stripes": "French Stripes",
    "cats_shirt": "Cool Cats Shirt",
    "singe_hoodie": "Singe Hoodie",
    "singe_hoodie_glow": "Singe Hoodie Glow",
    "applied_primate_coat": "Applied Primate Lab Coat",
    "btc_hoodie": "BTC Hoodie",
    "jacket": "Jacket",
    "blazer": "Blazer"
  },
  "mouth": {
    "apechain_grin": "Apechain Grin",
    "lollipop": "Lollipop",
    "banana_punch_gm": "Banana Punch GM",
    "banana_smile": "Banana Smile",
    "doodles_rainbow": "Doodles Rainbow",
    "big_smile": "Big Smile"
  },
  "hat": {
    "vegas": "Vegas BAYC",
    "german_ape_club_hat": "German Ape Club",
    "mindfully_bored_cap": "Mindfully Bored Cap",
    "apechain_cap": "Apechain Hat",
    "apechain_hat_blue": "Apechain Hat Blue",
    "apechain_hat_orange": "Apechain Hat Orange",
    "designer_toshiro_hat": "Designer Toshiro",
    "beret": "Béret",
    "cats_hat": "Cool Cats",
    "plunger": "Dookey Dash",
    "pudgy_hat": "Pudgy Penguins Hat",
    "pudgy_hat2": "Pudgy Penguins Hat 2",
    "glitter_cowboy_hat": "Glitter Cowboy Hat"
  },
  "eyes": {
    "vegas": "Vegas BAYC",
    "apecoin_glasses": "Apecoin Glasses",
    "apechain_glasses": "Apechain Glasses",
    "vision_pro": "Vision Pro",
    "dookey_eyes": "Dookey Dash",
    "btc_eyes": "BTC Coin",
    "star_glasses": "Star Glasses"
  },
  "hand": {
    "dr_bombay_strawberry_cream": "Dr. Bombay Strawberry Cream",
    "dr_bombay_baked_blueberry_muffin": "Dr. Bombay Baked Blueberry Muffin",
    "dr_bombay_iced_out_orange": "Dr. Bombay Iced Out Orange",
    "dr_bombay_peanut_butter": "Dr. Bombay Peanut Butter",
    "vegas": "Vegas BAYC",
    "ape_solar_sun_hand": "Ape Solar Sun Hand",
    "blever_pass": "Blever Pass",
    "gordon": "Gordon",
    "dookie_dash": "Dookie Dash",
    "smartphone_gm": "Smartphone GM",
    "sardines": "Lisbon Sardines",
    "ramen": "Ramen Bowl",
    "pray": "Pray",
    "basketball": "Basketball",
    "shiny-gm": "GM",
    "pipe": "Pipe",
    "thumbsup": "Thumbs Up",
    "magic_eden": "Magic Eden",
    "gm_espresso": "GM Espresso",
    "peace": "Peace",
    "cheers": "Cheers",
    "banana": "Banana Hand",
    "otherside": "Otherside Bottle",
    "apecoin_hands1": "Apecoin Hands 1",
    "apecoin_hands2": "Apecoin Hands",
    "moon_coffee": "Moon Coffee Company",
    "candle": "Candle",
    "balloon_fireworks": "Balloon & Fireworks",
    "fireworks": "Fireworks",
    "baguette": "Baguette",
    "clubhouse": "Clubhouse Sketch",
    "matchstick": "Matchstick",
    "balloon_moon": "2024 Balloon"
  },
  "extra": {
    "top_trader": "Top Trader",
    "top_trader_red": "Top Trader Red",
    "unclogged": "Unclogged",
    "hex_dark": "Hex Dark",
    "hex_light": "Hex Light",
    "small_ape": "Tiny AFA",
    "confetti": "Confetti",
    "snow": "Snow",
    "selfie": "Selfie Head",
    "transparent": "Transparent Background",
    "verified": "Verified",
    "vintage_frame": "Vintage Frame"
  }
};

export const assetLabel = (category, value) => (ASSET_LABELS[category] && ASSET_LABELS[category][value]) || '';
